import {
  LOAD_ZIP_SCRIPTS_REQUEST,
  LOAD_ZIP_SCRIPTS_SUCCESS,
  LOAD_ZIP_SCRIPTS_ERROR,
  ZIP_CHECKOUT_REQUEST,
  ZIP_CHECKOUT_SUCCESS,
  ZIP_CHECKOUT_ERROR
} from "../actions/zipMoneyActions";

const initialState = {
  scripts: {
    loading: false,
    error: false,
    loaded: false
  },
  checkout: {
    loading: false,
    error: false,
    loaded: false,
    id: null
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ZIP_SCRIPTS_REQUEST:
      return {
        ...state,
        scripts: {
          loading: true,
          error: false
        }
      };
    case LOAD_ZIP_SCRIPTS_SUCCESS:
      return {
        ...state,
        scripts: {
          loading: false,
          loaded: true,
          error: false
        }
      };
    case LOAD_ZIP_SCRIPTS_ERROR:
      return {
        ...state,
        scripts: {
          loading: false,
          error: true
        }
      };
    case ZIP_CHECKOUT_REQUEST:
      return {
        ...state,
        checkout: {
          loading: true,
          error: false
        }
      };
    case ZIP_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkout: {
          loading: false,
          loaded: true,
          error: false,
          id: action.checkout_id
        }
      };
    case ZIP_CHECKOUT_ERROR:
      return {
        ...state,
        checkout: {
          loading: false,
          error: true
        }
      };
    default:
      return state;
  }
};
export default {
  initialState,
  reducer
};
